import { render, staticRenderFns } from "./SubmissionStats.vue?vue&type=template&id=e8a62b48&"
import script from "./SubmissionStats.vue?vue&type=script&lang=js&"
export * from "./SubmissionStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports